export default (status) => {
  switch (status) {
    case "processed":
      return "#1AB975";
    case "cancelled":
      return "#F25700";
    case "processing":
      return "#4398D1";
    case "errored":
      return "#F25700";
  }
};

export const getWithDrawalAmountColor = (status) => {
  switch (status) {
    case "processed":
      return "#FF0000";
    case "cancelled":
      return "rgba(0, 0, 0, 0.36)";
    case "errored":
      return "rgba(0, 0, 0, 0.36)";
    case "processing":
      return "rgba(0, 0, 0, 0.87)";
  }
};
